/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".item-image[_ngcontent-%COMP%]{font-size:6em;color:#d3d3d3}.item-price[_ngcontent-%COMP%]{font-weight:700}.pb-4[_ngcontent-%COMP%], .py-4[_ngcontent-%COMP%]{padding-bottom:.5rem!important}"];
export { styles as styles };

